export default [
  {
    id: "PEN",
    name: 'Sin respuesta',
    detail: 'Pendientes',
    summary: 'Sin respuesta',
    color: 'yellow-100',
    icon: 'mdi-clock',
    key: 'Otros'
  },
  {
    id: "RCD",
    name: 'Reclamado',
    detail: 'Reclamo al Contenido del Documento',
    summary: 'Reclamado',
    color: 'red-100',
    icon: 'mdi-close',
    key: 'Reclamado'
  },
  {
    id: "RFP",
    name: 'Reclamado',
    detail: 'Reclamo por Falta Parcial de Mercaderías',
    summary: 'Reclamado',
    color: 'red-100',
    icon: 'mdi-close',
    key: 'Reclamado'
  },
  {
    id: "RFT",
    name: 'Reclamado',
    detail: 'Reclamo por Falta Total de Mercaderías',
    summary: 'Reclamado',
    color: 'red-100',
    icon: 'mdi-close',
    key: 'Reclamado'
  },
  {
    id: "ERM",
    name: 'Aceptado',
    detail: 'Otorga Recibo de Mercaderías o Servicios',
    summary: 'Aceptado',
    color: 'blue-100',
    icon: 'mdi-check',
    key: 'Otros'
  },
  {
    id: "PAG",
    name: 'Aceptado',
    detail: 'DTE pagado al contado',
    summary: 'Aceptado',
    color: 'blue-100',
    icon: 'mdi-check',
    key: 'Otros'
  },
  {
    id: "ACD",
    name: 'Aceptado',
    detail: 'Acepta Contenido del Documento',
    summary: 'Aceptado',
    color: 'blue-100',
    icon: 'mdi-check',
    key: 'Otros'
  },
  {
    id: "INV",
    detail: '',
    color: 'grey-200',
    summary: 'Inválido',
    icon: 'mdi-alert-circle',
    key: ''
  }
  // {
  //   id: "NCA",
  //   detail: 'Recepción de NC de anulación que referencia al documento',
  //   color: 'grey-200',
  //   summary: 'Anulado',
  //   icon: 'mdi-file-remove'
  // },
  // {
  //   id: "ENC",
  //   detail: 'Recepción de NC, distinta de anulación, que referencia al documento.',
  //   color: 'grey-200',
  //   summary: 'Anulado',
  //   icon: 'mdi-file-remove'
  // }
]